import { render, staticRenderFns } from "./VerticalScreen.vue?vue&type=template&id=19d4c9ad&scoped=true&"
import script from "./VerticalScreen.vue?vue&type=script&lang=js&"
export * from "./VerticalScreen.vue?vue&type=script&lang=js&"
import style0 from "./VerticalScreen.vue?vue&type=style&index=0&id=19d4c9ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4c9ad",
  null
  
)

export default component.exports